import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { IPagedResults } from '../../../services/mocks/mock.interfaces';
import { LoggerService } from '../../../shared/services/logger.service';
import { environment } from '../../../../environments/environment';
import { Authority } from '../..//../models/authority.model';
import { Session } from '../../../models/session.model';
import { Book } from 'src/app/models/book.model';
import { LibraryMember } from 'src/app/models/library-member.model';
import { BookIssue } from 'src/app/models/book-issue.model';
import { ItemCategory } from 'src/app/models/item-category.model';
import { ItemInventory } from 'src/app/models/item-inv.model';
import { ItemSupplier } from 'src/app/models/item-supplier.model';
import { ItemStore } from 'src/app/models/item-store.model';
import { ItemStock } from 'src/app/models/item-stock.model';
import { ItemIssue } from 'src/app/models/item-issue.model';
import { Student } from 'src/app/models/student.model';
import { OrderItem } from 'src/app/models/order-item.model';
import { OrderPayment } from 'src/app/models/order-payment.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private http: HttpClient,
              private logger: LoggerService) {
  }

  getItemCategoryListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/itemCategory?page='+page+'&size='+size);  
  }
  getItemCategoryList(): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/itemCategory/all');  
  }

  addItemCategory(itemcategory: ItemCategory): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/itemCategory',itemcategory);
  }
  getItemCategoryById(itemCategoryId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/itemCategory/get/'+itemCategoryId);
  }
  updateItemCategory(itemcategory: ItemCategory): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/itemCategory/update',itemcategory);
  }
  deleteItemCategory(itemCategoryId: number): Observable<any> { 
    return this.http.delete<any>(environment.authBase+'/inventory/itemCategory/delete/'+itemCategoryId);
  }
  /**********************************Item**********************************/
  getItemListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/item?page='+page+'&size='+size);  }
  
  getItemListByCategory(itemCategoryId: number, itemForSale: boolean): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/item/category/'+itemCategoryId+'/'+itemForSale);
  }
  getItemAllListByCategory(itemCategoryId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/item/category/all/'+itemCategoryId);
  }

  addItem(item: ItemInventory): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/item',item);
  }
  getItemById(itemId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/item/get/'+itemId);
  }
  updateItem(item: ItemInventory): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/item/update',item);
  }
  deleteItem(itemId: number): Observable<any> { 
    return this.http.delete<any>(environment.apiBase+'/inventory/item/delete/'+itemId);
  }
  /**********************************Supplier**********************************/
  getSupplierListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/supplier?page='+page+'&size='+size);  
  }
  getSupplierList(): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/supplier/all');  
  }

  addSupplier(supplier: ItemSupplier): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/supplier',supplier);
  }
  getSupplierById(supplierId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/supplier/get/'+supplierId);
  }
  updateSupplier(supplier: ItemSupplier): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/supplier/update',supplier);
  }
  deleteSupplier(supplierId: number): Observable<any> { 
    return this.http.delete<any>(environment.apiBase+'/inventory/supplier/delete/'+supplierId);
  }
  /**********************************Store**********************************/
  getStoreListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/store?page='+page+'&size='+size);  
  }
  getStoreList(): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/store/all');  
  }

  addStore(store: ItemStore): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/store',store);
  }
  getStoreById(storeId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/store/get/'+storeId);
  }
  updateStore(store: ItemStore): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/store/update',store);
  }
  deleteStore(storeId: number): Observable<any> { 
    return this.http.delete<any>(environment.apiBase+'/inventory/store/delete/'+storeId);
  }
  /**********************************Stock**********************************/
  getStockListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/stock?page='+page+'&size='+size);  }

  addStock(stock: ItemStock): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/stock',stock);
  }
  getStockById(stockId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/stock/get/'+stockId);
  }
  getStockByItemId(itemId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/stock/item/'+itemId);
  }
  updateStock(stock: ItemStock): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/stock/update',stock);
  }
  deleteStock(stockId: number): Observable<any> { 
    return this.http.delete<any>(environment.apiBase+'/inventory/stock/delete/'+stockId);
  }
  /**********************************Issue Item**********************************/
  getItemIssueListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/itemIssue?page='+page+'&size='+size);  
  }
  getIssueDetailById(issueId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/itemIssue/get/'+issueId);
  }
  issueItem(itemIssue: ItemIssue): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/itemIssue',itemIssue);
  }
  updateIssueItem(itemIssue: ItemIssue): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/itemIssue/update',itemIssue);
  }
  returnItem(itemIssue: ItemIssue): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/itemIssue/return',itemIssue);
  }

  /****************************************Order Item***********************************/
  getOrderListPage(page: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/inventory/order?page='+page+'&size='+size);  
  }
  createOrderItem(orderItemList: OrderItem[], admNumber: string, activeSession: string): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/createOrder/'+admNumber+'/'+activeSession,orderItemList);
  }
  getOrderById(id: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/order/get/'+id);
  }
  checkNGetOrderById(id: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/checkorder/get/'+id);
  }
  cancelOrder(id: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/order/cancel/'+id);
  }
  deliveryOrder(id: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/order/delivery/'+id);
  }
  paymentOrder(orderId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/inventory/order/payment/'+orderId);
  }
  renderReceiptPdf(paymentId: number): any {  
    let params = {location: "report.pdf"};
    return this.http.get(environment.apiBase+'/inventory/payment/receipt/'+paymentId, {responseType : 'blob'});   
  }
  generateReceipt(orderId: number):Observable<any> {   
    return this.http.get(environment.apiBase+'/inventory/payment/receipt/generate/'+orderId);   
  }
  updateOrderItem(orderItem: OrderItem): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/orderItem/update',orderItem);
  }
  updatePayment(itemId: number, orderPayment: OrderPayment): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/inventory/payment/update/'+itemId, orderPayment);
  }
  /****************************************Temporary***********************************/
  getStudentList(logginUserRole: string, userName: string): Observable<Student[]> {  
    if(logginUserRole == environment.ROLE_PARENT){
      return this.http.get<Student[]>(environment.apiBase+'/inventory/studentsForParent/'+userName);
    }else{
      return this.http.get<Student[]>(environment.apiBase+'/inventory/students');
    }
  }
  //getStudentsForParent(parentUser: string): Observable<Student[]> {}
}
